import { render, staticRenderFns } from "./SawmachinePage.vue?vue&type=template&id=8920db1e"
import script from "./SawmachinePage.vue?vue&type=script&lang=js"
export * from "./SawmachinePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports